var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content-left" }, [
    _c(
      "div",
      { staticClass: "image-box" },
      [
        _c(
          "el-upload",
          {
            ref: "upload",
            staticClass: "avatar-uploader",
            attrs: {
              action: _vm.actionUrl,
              headers: _vm.headers,
              "show-file-list": false,
              "before-upload": _vm.beforeAvatarUpload,
              "on-success": _vm.handleAvatarSuccess,
              disabled: !_vm.btnStatus.btnEditTeam,
              accept: "image/png, image/jpeg, image/jpg",
            },
          },
          [
            _vm.teamData.imgUrl
              ? _c("img", {
                  staticClass: "avatar",
                  attrs: { src: _vm.teamData.imgUrl },
                })
              : _c("i", { staticClass: "el-icon-plus avatar-uploader-icon" }),
          ]
        ),
      ],
      1
    ),
    _c(
      "p",
      [
        _c("el-tag", { attrs: { size: "mini" } }, [
          _vm._v(" " + _vm._s(_vm.$t("teamDetail.TDMC")) + " "),
        ]),
        !_vm.isModifyTeamName
          ? _c(
              "span",
              {
                staticClass: "team-name nowrap vertical_align",
                attrs: { title: _vm.teamData.teamName },
              },
              [_vm._v(_vm._s(_vm.teamData.teamName))]
            )
          : _c("el-input", {
              staticStyle: { width: "150px" },
              attrs: {
                size: "mini",
                maxlength: "20",
                placeholder: _vm.$t("teamDetail.QSRXDTDMC"),
              },
              on: {
                blur: function ($event) {
                  _vm.$parent.saveTeam(_vm.teamName)
                  _vm.isModifyTeamName = false
                },
              },
              model: {
                value: _vm.teamName,
                callback: function ($$v) {
                  _vm.teamName = $$v
                },
                expression: "teamName",
              },
            }),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.btnStatus.btnEditTeam,
              expression: "btnStatus.btnEditTeam",
            },
          ],
          staticClass: "icon-modify el-icon-edit-outline",
          on: {
            click: () => {
              _vm.isModifyTeamName ? _vm.$parent.saveTeam(_vm.teamName) : ""
              _vm.isModifyTeamName = !_vm.isModifyTeamName
            },
          },
        }),
      ],
      1
    ),
    _c(
      "p",
      [
        _c("el-tag", { attrs: { size: "mini" } }, [
          _vm._v(" " + _vm._s(_vm.$t("teamDetail.DZXM")) + " "),
        ]),
        _c(
          "span",
          {
            staticClass: "leader-name nowrap vertical_align",
            attrs: { title: _vm.teamData.leaderName },
          },
          [_vm._v(" " + _vm._s(_vm.teamData.leaderName) + " ")]
        ),
      ],
      1
    ),
    _c(
      "p",
      [
        _c("el-tag", { attrs: { size: "mini" } }, [
          _vm._v(" " + _vm._s(_vm.$t("teamDetail.TDZT")) + " "),
        ]),
        _c(
          "span",
          {
            staticClass: "status-text vertical_align",
            class: {
              red: _vm.teamData.createStatus == 0,
              green: _vm.teamData.createStatus != 0,
            },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.teamData.createStatus == 0
                    ? _vm.$t("teamDetail.ZJZ")
                    : _vm.teamData.createStatus == 2
                    ? _vm.$t("teamDetail.JXZ")
                    : _vm.$t("teamDetail.YJX")
                ) +
                " "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }